/* eslint-disable no-bitwise */
var keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
/**
 * utf-8 编码
 * @param {*} string
 */

function utf8Encode(string) {
  string = string.replace(/\r\n/g, '\n');
  var utftext = '';

  for (var n = 0; n < string.length; n++) {
    var c = string.charCodeAt(n);

    if (c < 128) {
      utftext += String.fromCharCode(c);
    } else if (c > 127 && c < 2048) {
      utftext += String.fromCharCode(c >> 6 | 192);
      utftext += String.fromCharCode(c & 63 | 128);
    } else {
      utftext += String.fromCharCode(c >> 12 | 224);
      utftext += String.fromCharCode(c >> 6 & 63 | 128);
      utftext += String.fromCharCode(c & 63 | 128);
    }
  }

  return utftext;
}
/**
 * utf-8解码
 * @param {}} utftext
 */


function utf8Decode(utftext) {
  var string = '';
  var i = 0;
  var c = 0;
  var c1 = 0;
  var c2 = 0;
  var c3 = 0;

  while (i < utftext.length) {
    c = utftext.charCodeAt(i);

    if (c < 128) {
      string += String.fromCharCode(c);
      i++;
    } else if (c > 191 && c < 224) {
      c2 = utftext.charCodeAt(i + 1);
      string += String.fromCharCode((c & 31) << 6 | c2 & 63);
      i += 2;
    } else {
      c2 = utftext.charCodeAt(i + 1);
      c3 = utftext.charCodeAt(i + 2);
      string += String.fromCharCode((c & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
      i += 3;
    }
  }

  return string;
}
/**
 * base64编码
 */


var encode = function () {
  // if (window.atob) {
  //   return function (string) {
  //     window.atob(unescape(encodeURIComponent(string)));
  //   };
  // }
  return function (string) {
    // 处理中文utf8文本
    var input = utf8Encode(string); // 转换成base64

    var output = '',
        chr1 = '',
        chr2 = '',
        chr3 = '',
        enc1 = '',
        enc2 = '',
        enc3 = '',
        enc4 = '',
        i = 0;

    while (i < input.length) {
      chr1 = String(input.charCodeAt(i++));
      chr2 = String(input.charCodeAt(i++));
      chr3 = String(input.charCodeAt(i++));
      enc1 = String(chr1 >> 2);
      enc2 = (chr1 & 3) << 4 | chr2 >> 4;
      enc3 = (chr2 & 15) << 2 | chr3 >> 6;
      enc4 = chr3 & 63;

      if (isNaN(chr2)) {
        enc3 = 64;
        enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }

      output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
    }

    return output;
  };
}();
/**
 * base64解码
 */


var decode = function () {
  return function (input) {
    var output = '';
    var chr1 = -1;
    var chr2 = -1;
    var chr3 = -1;
    var enc1 = -1;
    var enc2 = -1;
    var enc3 = -1;
    var enc4 = -1;
    var i = 0;
    input = input.replace(/[^A-Za-z0-9+/=]/g, '');

    while (i < input.length) {
      enc1 = keyStr.indexOf(input.charAt(i++));
      enc2 = keyStr.indexOf(input.charAt(i++));
      enc3 = keyStr.indexOf(input.charAt(i++));
      enc4 = keyStr.indexOf(input.charAt(i++));
      chr1 = enc1 << 2 | enc2 >> 4;
      chr2 = (enc2 & 15) << 4 | enc3 >> 2;
      chr3 = (enc3 & 3) << 6 | enc4;
      output += String.fromCharCode(chr1);

      if (enc3 !== 64) {
        output += String.fromCharCode(chr2);
      }

      if (enc4 !== 64) {
        output += String.fromCharCode(chr3);
      }
    }

    output = utf8Decode(output);
    return output;
  };
}();

export default {
  encode: encode,
  decode: decode,
  utf8Encode: utf8Encode,
  utf8Decode: utf8Decode
};